import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ProfessionalCollaboration() {
  return <section data-section-id="99462" id="consulting-program-development" className="bg-primary text-primary-foreground py-32 md:py-[160px] px-6 md:px-12 flex flex-col items-center justify-center">
      <div className="max-w-4xl mx-auto text-center flex flex-col items-center">
        <h2 className="font-sans text-4xl md:text-5xl lg:text-7xl font-black leading-tight tracking-tighter text-primary-foreground">
          Ready to Implement Global Best Practices?
        </h2>
        
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
          <Button asChild size="lg" className="w-full sm:w-auto rounded-sm text-base px-8 h-14 bg-primary-foreground text-primary hover:bg-primary-foreground/90">
            <Link to="/ContactPage">Contact Services</Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto rounded-sm text-base px-8 h-14 border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary bg-transparent">
            <Link to="#">
              Download Compliance Guide
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}